import "fonts.js";
import "index.scss";

import { BugsnagUtils, isValidHostname } from "utils";

import App from "App";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom";
import { initializePosthog } from "utils/analytics";

/**
 * Renders the application as normal.
 * This is called _after_ we verify the hostname.
 * https://civicscience.atlassian.net/browse/CS-3706
 */
const renderApplication = () => {
  const posthog = initializePosthog();
  BugsnagUtils.initialize();

  const AppToRender = (
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </React.StrictMode>
  );

  ReactDOM.render(AppToRender, document.getElementById("root"));
};

/**
 * Renders an error message for users accessing the application from an unauthorized domain.
 */
const renderUnauthorizedHostError = () => {
  const hostname = window.location.hostname;
  document.getElementById("root").innerHTML = `
    <div style="margin: 2rem auto; text-align: center; max-width: 600px;">
      <h1>Access Denied</h1>
      <p>The CivicScience InsightStore cannot be accessed from domain: <strong>${hostname}</strong></p>
      <p>Please contact your administrator if you believe this is an error.</p>
    </div>`;
};

isValidHostname(window.location.hostname) ? renderApplication() : renderUnauthorizedHostError();
